var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7965 10.8479C15.3338 6.31069 21.607 3.50122 28.533 3.50122C35.4591 3.50122 41.7323 6.31069 46.2696 10.848C50.8069 15.3853 53.6164 21.6585 53.6164 28.5846C53.6164 35.5106 50.8069 41.7838 46.2696 46.3211C41.7323 50.8584 35.4591 53.6679 28.533 53.6679C21.607 53.6679 15.3338 50.8584 10.7964 46.3211C6.25919 41.7838 3.44971 35.5106 3.44971 28.5846C3.44971 21.6585 6.2592 15.3853 10.7965 10.8479ZM28.533 7.00122C22.5725 7.00122 17.1791 9.4151 13.2713 13.3228C9.36357 17.2306 6.94971 22.6241 6.94971 28.5846C6.94971 34.5451 9.36359 39.9385 13.2713 43.8462C17.1791 47.754 22.5725 50.1679 28.533 50.1679C34.4935 50.1679 39.887 47.754 43.7947 43.8462C47.7025 39.9385 50.1164 34.545 50.1164 28.5846C50.1164 22.6241 47.7025 17.2306 43.7947 13.3228C39.887 9.4151 34.4935 7.00122 28.533 7.00122Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.533 43.7512C30.1439 43.7512 31.4497 42.4454 31.4497 40.8346C31.4497 39.2237 30.1439 37.9179 28.533 37.9179C26.9222 37.9179 25.6164 39.2237 25.6164 40.8346C25.6164 42.4454 26.9222 43.7512 28.533 43.7512Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.533 12.8346C29.4995 12.8346 30.283 13.6181 30.283 14.5846V33.2512C30.283 34.2177 29.4995 35.0012 28.533 35.0012C27.5665 35.0012 26.783 34.2177 26.783 33.2512V14.5846C26.783 13.6181 27.5665 12.8346 28.533 12.8346Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.d87f7b08.svg";
export { ForwardRef as ReactComponent };